import CityPageTemplate from "@/components/site/CityPageTemplate";

export default function FinanzberatungKrefeld() {
  return (
    <CityPageTemplate
      city="Krefeld"
      slug="krefeld"
      intro="Krefeld mit seiner starken Mittelstandskultur – unabhängige Finanzberatung für Angestellte und Selbständige."
      description="Unabhängige & digitale Finanzberatung für Krefeld: Altersvorsorge, ETF, Steueroptimierung und staatliche Förderungen. Kostenlose Erstberatung – 100% digital."
    />
  );
}
